module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/scal360/view-scal360-purchase-history/view-scal360-purchase-history.component.css
// module id = 997
// module chunks = 1